import { Component, OnInit } from '@angular/core';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';

@Component({
  selector: 'app-query-reply',
  templateUrl: './query-reply.component.html',
  styleUrls: ['./query-reply.component.scss']
})
export class QueryReplyComponent implements OnInit {

  constructor(public userUtilsService:UserUtilService) { }

  ngOnInit(): void {
  }

}
